import { render } from "./BatchClassAttributesForm.vue?vue&type=template&id=a112cae6&scoped=true&ts=true"
import script from "./BatchClassAttributesForm.vue?vue&type=script&lang=ts"
export * from "./BatchClassAttributesForm.vue?vue&type=script&lang=ts"

import "./BatchClassAttributesForm.vue?vue&type=style&index=0&id=a112cae6&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a112cae6"]])

export default __exports__